<template>
  <v-container fluid>
    <div>
      <v-card width="450px" class="text-align: center;">
        <v-card-title>
          <h1>Sign Up</h1>
        </v-card-title>
        <form>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="user_types"
                  v-model="register.user_type"
                  label="User Type"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="zones"
                  v-model="register.zone"
                  label="Zone"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="divisions"
                  v-model="register.division"
                  label="Division"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="email"
                  label="Email"
                  id="email"
                  type="email"
                  v-model="register.username"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="password"
                  label="Password"
                  id="password"
                  type="password"
                  v-model="register.password"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="confirmPassword"
                  label="Confirm Password"
                  id="confirmPassword"
                  type="password"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col cols="12">
              <v-btn color="primary" @click="onSubmit()">Create</v-btn>
              <v-btn color="primary" @click="onUpdate()">Update</v-btn>
            </v-col>
          </v-card-actions>
        </form>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Register",
  data() {
    return {
      user_types: [
        "Admin",
        "TLC",
        "CLI",
        "DTNL", 
        "SDAH_RRI_NORTH",
        "SDAH_RRI_SOUTH",
        "Guest",
        "HOG"
      ],
      zones: [
        "ER",
        "SR",
        "WR",
        "CR",
        "SER",
        "ECR",
      ],
      divisions: [
        "ASN",
        "HWH",
        "MLDT",
        "SDAH",
        "MAS",
      ],
      register: {},
      errors: [],
    };
  },
  methods: {
    onSubmit() {
      console.log(this.register);
      //  evt.preventDefault()
      axios
        .post(`${process.env.VUE_APP_API_URL}/auth/register/`, this.register)
        .then((response) => {
          //alert("Registered successfully")
          this.$router.push({
            name: "Signin",
          });
        })
        .catch((e) => {
          console.log(e);
          this.errors.push(e);
        });
    },

    onUpdate() {
      console.log(this.register);
      //  evt.preventDefault()
      axios
        .put(`${process.env.VUE_APP_API_URL}/auth/`, this.register)
        .then((response) => {
          //alert("Registered successfully")
          this.$router.push({
            name: "Signin",
          });
        })
        .catch((e) => {
          console.log(e);
          this.errors.push(e);
        });
    },
  },
};
</script>
